export enum InputType {
    Text = 'TEXT',
    Essay = 'ESSAY',
    Signature = 'SIGNATURE',
    Email = 'EMAIL'
}
